import { useState, useEffect, useCallback, useRef } from "react"
import { fetchNotifications, markNotificationRead, markAllRead } from "../api/notificationsApi"

const POLL_INTERVAL = 30_000 // 30 s

export function useNotifications() {
  const [notifications, setNotifications] = useState([])
  const [unreadCount, setUnreadCount] = useState(0)
  const [loading, setLoading] = useState(true)
  const timerRef = useRef(null)

  const load = useCallback(async () => {
    try {
      const data = await fetchNotifications()
      setNotifications(data.notifications || [])
      setUnreadCount(data.unread_count || 0)
    } catch {
      // silently fail — bell just shows 0
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    load()
    timerRef.current = setInterval(load, POLL_INTERVAL)
    return () => clearInterval(timerRef.current)
  }, [load])

  const markRead = useCallback(async (id) => {
    const updated = await markNotificationRead(id)
    setNotifications((prev) =>
      prev.map((n) => (n.id === id ? { ...n, read: true, read_at: updated.read_at } : n))
    )
    setUnreadCount((c) => Math.max(0, c - 1))
  }, [])

  const markAll = useCallback(async () => {
    await markAllRead()
    setNotifications((prev) => prev.map((n) => ({ ...n, read: true })))
    setUnreadCount(0)
  }, [])

  return { notifications, unreadCount, loading, markRead, markAll, refresh: load }
}
